module.exports = __webpack_public_path__ + "img/huangjin.b96c2d6b.png";